import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import State from './types'
import { RootState } from '../types'

export const state: State = {
  treeLoading: false,
  reloadTree: false,
}

const namespaced = true

export const tree: Module<State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
